<div class="">
     <app-side-navbar></app-side-navbar>
     @if (showSpricedFooter) {
       <app-spriced-footer></app-spriced-footer>
     }
</div>
